export default {
    'name': 'dot',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<circle cx=\'8\' cy=\'8\' r=\'4\' fill=\'#42A463\'/>'
}
